import script from "./Initiate.vue?vue&type=script&setup=true&lang=js"
export * from "./Initiate.vue?vue&type=script&setup=true&lang=js"

import "./Initiate.vue?vue&type=style&index=0&id=81f6c314&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81f6c314"]])

export default __exports__